import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextAreaField } from 'shared/containers/portal_layout/HForm';
import { reduxForm } from 'utils/reduxFormWrapper';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import api from 'utils/api';
import { decamelizeKeys } from 'humps';
import Errors from 'shared/components/Errors';
import SpinnerButton from 'shared/components/SpinnerButton';

class AppointmentCanceller extends Component {
  constructor(props, context) {
    super(props, context);
    this.cancelAppointment = this.cancelAppointment.bind(this);
  }

  cancelAppointment(formValues) {
    return api
      .post(
        `${this.props.apiEndpoint}/appointments/${this.props.appointmentId}/cancellations`,
        decamelizeKeys(formValues)
      )
      .then(response => {
        this.props.handleSuccess();
        FlashMessageActions.flashSuccess({
          message: 'You have successfully cancelled the appointment for this referral',
        });
        return null;
      });
  }

  render() {
    return (
      <FormifiedPresentationComponent
        form="appointmentCancellation"
        onSubmit={this.cancelAppointment}
      />
    );
  }
}

AppointmentCanceller.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func.isRequired,
};

const PresentationComponent = props => (
  <form onSubmit={props.handleSubmit}>
    <div className="modal-header">
      <h3>Cancel Appointment</h3>
    </div>
    <div className="modal-body" style={{ width: '600px' }}>
      <Errors errors={props.error || []} />
      <TextAreaField name="reason" label="Cancellation Reason" />
    </div>
    <div className="modal-footer">
      <SpinnerButton type="submit" className="btn btn-primary" loading={props.submitting}>
        Cancel Appointment
      </SpinnerButton>
    </div>
  </form>
);

PresentationComponent.displayName = 'PresentationComponent';

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

export default AppointmentCanceller;
